module.exports = __webpack_public_path__ + "static/media/splash3_1x.7c5fea0c.jpg";